import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationResult } from 'react-query';
import { useGetCrmAccessControlApi } from './use-get-crm-access-control-api';

const endpoint = 'ums/v1/crm/management/accesses';

export interface CreateAccessControlRequest {
  userId: number;
}

export interface CreateAccessControlResponse {
  message: string;
  success: boolean;
}

type TData = CreateAccessControlResponse;
type TError = AxiosError;
type TVariables = CreateAccessControlRequest;
type Options = any;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useCreateAccessControlApi(options?: Options): ReturnType {
  const { refetch: refetchAccessControl } = useGetCrmAccessControlApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async (data: TVariables) => {
    try {
      const { data: responseData } = await http.post(endpoint, data);

      // Refetch access control list
      refetchAccessControl();

      toast({
        description: 'Access control created successfully',
        status: 'success',
      });

      return responseData;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
